/* eslint-disable @typescript-eslint/no-explicit-any */
import type { TypedDocumentNode } from "@graphql-typed-document-node/core";
import type { VariablesOf, ResultOf } from "gql.tada";
import { REQUEST_TIMEOUT } from "./constants";
import { gqlFetchWithAuth } from "./gqlFetchWithAuth";
import type { FetchError } from "./types";

export const fetchData = <Query extends TypedDocumentNode<any, any>>({
  query,
  onSuccess,
  onError,
  setIsLoading,
  variables,
  signal,
  timeout = REQUEST_TIMEOUT,
}: {
  query: Query;
  onSuccess: (data: ResultOf<Query>) => void;
  onError: (error: FetchError) => void;
  variables?: VariablesOf<Query>;
  signal?: AbortSignal;
  setIsLoading?: (isLoading: boolean) => void;
  timeout?: number;
}) => {
  setIsLoading?.(true);
  gqlFetchWithAuth({ query, variables, signal, timeout })
    .then((data) => onSuccess(data))
    .catch((error: FetchError) => onError(error))
    .finally(() => setIsLoading?.(false));
};
